import { last } from 'lodash/fp'

// Emulate the path.basename node function
export default function basename(path: string, extension?: string) {
  const fragments = path.split('/')
  const lastFragment = last(fragments)

  return lastFragment ? lastFragment.replace(extension || '', '') : ''
}
